import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useMgaSheetColumn, type MgaSheetColumn } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<MgaSheetColumn>
    useData={useMgaSheetColumn}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
